import { useEffect, useState, type ReactNode } from "react";
import { ConfirmDialog } from "./ConfirmDialog";
import { PromptDialog } from "./PromptDialog";

/**
 * Çift onaylı kalıcı silme akışı (süper admin).
 * Adım 1: tehlike uyarısı (ConfirmDialog).
 * Adım 2: doğrulama için kodu yazma (PromptDialog, kod birebir eşleşmeli).
 * Mutation'ı ÜST bileşen yürütür (onConfirmed); busy/errorMessage dışarıdan gelir.
 */
interface Props {
  open: boolean;
  /** Doğrulamak için yazılacak kod (kart/reçete kodu). */
  code: string;
  title: string;
  /** Adım 1 tehlike açıklaması. */
  warning: ReactNode;
  busy?: boolean;
  /** Sunucudan dönen engelleme/hatası (adım 2'de gösterilir). */
  errorMessage?: string | null;
  /** Her iki onay geçtiğinde — üst bileşen mutation'ı tetikler. */
  onConfirmed: () => void;
  onClose: () => void;
}

export function HardDeleteConfirm({ open, code, title, warning, busy, errorMessage, onConfirmed, onClose }: Props) {
  const [step, setStep] = useState<"warn" | "type">("warn");

  useEffect(() => {
    if (open) setStep("warn");
  }, [open]);

  if (!open) return null;

  if (step === "warn") {
    return (
      <ConfirmDialog
        open
        title={title}
        tone="danger"
        confirmLabel="Devam Et"
        cancelLabel="Vazgeç"
        message={warning}
        onConfirm={() => setStep("type")}
        onCancel={onClose}
      />
    );
  }

  return (
    <PromptDialog
      open
      title={title}
      tone="danger"
      icon="trash"
      label="Onay kodu"
      placeholder={code}
      confirmLabel="Kalıcı Sil"
      cancelLabel="Vazgeç"
      busy={busy}
      message={
        <>
          {errorMessage ? <div className="form-banner-err" role="alert" style={{ marginBottom: 10 }}>{errorMessage}</div> : null}
          <div>
            Bu işlem <b>geri alınamaz</b>. Onaylamak için <b style={{ fontFamily: "var(--font-mono)" }}>{code}</b> kodunu yazın.
          </div>
        </>
      }
      validate={(v) => (v === code ? null : "Kod eşleşmiyor.")}
      onConfirm={() => onConfirmed()}
      onCancel={onClose}
    />
  );
}
